// js/sections/RecentlyViewedProductsSection.js
import { SecureStorage } from '../utils.js';
import { shopifySectionsAPI } from '../utils/shopify-sections-api.js';

class RecentlyViewedProductsSection extends HTMLElement {
  connectedCallback() {
    this.settings = JSON.parse(this.getAttribute("data-settings")) || {};
    this.settings["ignoreIds"] = this.settings["ignoreIds"] || [];

    this._fetchProducts();
  }
  disconnectedCallback() {
    // Slider cleanup is handled by cos-flickity component
  }
  /**
   * In order to get the products to display, we hit the search template with the given IDs.
   */
  async _fetchProducts() {
    const queryString = this._getSearchQueryString();
    
    if (queryString === "" || this.getAttribute("initialized")) {
      this._handleHeadingVisibility(false);
      this._handleSectionVisibility(false);
      return;
    } 
    
    // Prevent multiple simultaneous calls
    if (this._isLoading) {
      return;
    }
    this._isLoading = true;
    
    this._handleHeadingVisibility(true);
    
    try {
      // Use the unified fetchProducts method with search API
      const productIds = this._getProductIds();
      
      const products = await shopifySectionsAPI.fetchProducts(productIds, this.settings["sectionId"] || 'main-search');
      
      const productsContainer = this.querySelector('[data-products-grid]');
      
      if (products && products.length > 0 && productsContainer) {
        // Use the shared rendering utility
        shopifySectionsAPI.renderProducts(products, productsContainer, {
          emptyMessage: ''
        });
        
        this.setAttribute("initialized", "true");
        this._handleSectionVisibility(true);
        
        // Reinitialize slider after products are loaded
        requestAnimationFrame(() => {
          const slider = this.querySelector('cos-slider');
          
          if (slider && typeof slider.reinitialize === 'function') {
            slider.reinitialize();
          }
        });
      } else {
        this._handleSectionVisibility(false);
      }
    } catch (error) {
      this._handleSectionVisibility(false);
    } finally {
      this._isLoading = false;
    }
  }
  _getProductIds() {
    let items = SecureStorage.getJSON("recentlyViewedProducts", []);
    
    // ignoreIds is an array of ids
    this.settings["ignoreIds"].forEach((id) => {
      if (items.includes(id)) {
        items.splice(items.indexOf(id), 1);
      }
    });
    
    return items;
  }
  
  _getSearchQueryString() {
    let items = SecureStorage.getJSON("recentlyViewedProducts", []);
    
    // ignoreIds is an array of ids
    this.settings["ignoreIds"].forEach((id) => {
      if (items.includes(id)) {
        items.splice(items.indexOf(id), 1);
      }
    });
    
    const queryString = items.map((item) => {
      return "id:" + item;
    }).join(" OR ");
    
    return queryString;
  }
  _handleHeadingVisibility(visible) {
    const heading = this.parentElement.querySelector(".section__title");
    if (!heading) return;

    heading.style.display = visible ? "block" : "none";
  }
  _handleSectionVisibility(visible) {
    const section = this.closest('[data-section-type="recently-viewed-products"]');
    if (!section) return;

    section.style.display = visible ? "block" : "none";
  }
};
if (!window.customElements.get("cos-recently-viewed-products")) window.customElements.define("cos-recently-viewed-products", RecentlyViewedProductsSection);
